import { render, staticRenderFns } from "./AsideTools.vue?vue&type=template&id=7a1da38b&"
import script from "./AsideTools.vue?vue&type=script&lang=ts&"
export * from "./AsideTools.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports